var React = require('react');

function ToastClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M6 18 18 6M6 6l12 12"}));
}

ToastClose.defaultProps = {"fill":"none","viewBox":"0 0 24 24","width":"24","height":"24","strokeWidth":"1.5","stroke":"currentColor"};

module.exports = ToastClose;

ToastClose.default = ToastClose;
